module.exports = __webpack_public_path__ + "assets/icon-calculator.b6052a56.svg";